// extracted by mini-css-extract-plugin
export default {"avatar-box":"UserAvatar_avatar-box__9KFY2","user-avatar":"UserAvatar_user-avatar__PDUT1"};